/**
 * Сховища розширених фільтрів (прототип v4: умови модуля, «застосовується до всіх подань цього модуля», зберігаються між сесіями):
 * ключ `воркспейс|тип запису` → рядки умов і значення швидких полів (поле → значення).
 */
import type { IAdvancedCondition } from './IAdvancedCondition';
import { createKeyedStore } from './keyedStore';

const NO_CONDITIONS: IAdvancedCondition[] = [];
const NO_QUICK: Record<string, string> = {};

/** Ключ фільтрів: воркспейс і тип запису. */
export const advancedKey = (ws: string, rt: string): string => `${ws}|${rt}`;

/** Рядки умов розширених фільтрів. */
export const conditionsStore = createKeyedStore<IAdvancedCondition[]>('po.advancedFilters.v1', NO_CONDITIONS);

/** Значення швидких полів панелі розширених фільтрів (виконавець, пріоритет, термін). */
export const quickFieldsStore = createKeyedStore<Record<string, string>>('po.quickFields.v1', NO_QUICK);
